<template>
  <div
    :id="`undo-delete-toast-${uid}`"
    class="toast fade m-auto mb-1 mb-md-3 ms-md-auto me-md-3"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    data-bs-delay="15000"
  >
    <div class="custom-toast-body text-bg-secondary cow-toast-info">
      <strong class="me-auto">{{ message }}</strong>
      <form @submit.prevent="undoClicked">
        <button
          class="btn btn-secondary"
          data-bs-dismiss="toast"
        >
          Undo
        </button>
      </form>
      <button
        type="button"
        class="btn-close me-1"
        data-bs-dismiss="toast"
        aria-label="Close"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import Toast from 'bootstrap/js/dist/toast';
import { useUid } from '@app/composables/useUid';

type UndoDeleteFn = () => void;

const props = defineProps<{
  message: string;
  undoDelete: UndoDeleteFn;
}>();

const uid = useUid();

const sentUndo = ref(false);

function undoClicked() {
  if (!sentUndo.value) {
    sentUndo.value = true;
    props.undoDelete();
    // TODO hide the toast?
  }
}

onMounted(() => {
  const toast = document.getElementById(`undo-delete-toast-${uid}`);
  if (toast) {
    // eslint-disable-next-line no-new
    new Toast(toast).show();
  }
});
</script>

<style>
.custom-toast-body {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  border-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
</style>
